<template>
    <h1>Seleccione sucursal </h1>
    <Dropdown v-if="idCompany == 1" v-model="seleccionarSucursal" @change="accesoSucursal" :options="establecimientos"  optionLabel="nombre" placeholder="Seleccione sucursal"  class="w-full md:w-40rem"/>
    <Dropdown v-if="idCompany == 2" v-model="seleccionarSucursal" @change="accesoSucursal" :options="establecimientossermie"  optionLabel="nombre" placeholder="Seleccione sucursal"  class="w-full md:w-40rem"/>

    <Dialog v-model:visible="visible" modal header="{{nameLocal.value}}" :style="{ width: '50rem' }">
        
            <template #header>
                <div class="inline-flex align-items-center justify-content-center gap-2">
                    <Avatar icon="pi pi-home" class="mr-2" size="large" style="background-color: #ece9fc; color: #2a1261" shape="circle" />
                    <span class="font-bold white-space-nowrap">{{nameLocal}}</span>
                </div>
            </template>
        
            <span class="p-text-secondary block mb-5">Ingrese codigo de acceso para ingresar a su unidad</span>
        
            <div class="flex align-items-center gap-3 mb-2">
                <label for="email" class="font-semibold w-6rem">Clave</label>
                <InputText  v-model="passLocal" @keyup.enter.native="acceder()"class="flex-auto" :feedback="false" variant="filled" toggleMask />
                <InlineMessage v-if="resp_acceso == false" severity="error">Acceso denegado</InlineMessage>
                <InlineMessage v-if="resp_acceso == true" severity="success">Acceso Autorizado</InlineMessage>
            </div>

      
            <template #footer>
                <Button label="Cancel" text severity="secondary" @click="visible = false" autofocus />
                <Button label="Ingresar" outlined severity="secondary" @click="acceder()" autofocus />
            </template>
        
        <ProgressBar v-if="(loading)" mode="indeterminate" style="height: 6px"></ProgressBar>
    </Dialog>

    <BlockUI :blocked="blocked" fullScreen />

</template>

<script setup>

    import * as surcusalservice from "@/services/sucursal.service.js"
    import { ref, onMounted } from 'vue'
    import  router from '@/router';

    import ProgressBar from 'primevue/progressbar';
    import BlockUI from 'primevue/blockui';

    var datos_company = ref(JSON.parse(localStorage.getItem("company")));
    
    let visible = ref();

    let seleccionarSucursal = ref();

    let establecimientos =ref([
        { 
            codLocal: "0011",direccion: "CAL.ALBERT EINSTEIN NRO. 334 URB. LA CALERA DE LA MERCED LIMA - LIMA - SURQUILLO",
            ubigeo: "150141", nombre: "Oficina Surquillo" , ruc:'20513963085'
        },
        { 
            codLocal: "0006",direccion: "CAL.MACHU PICCHU MZA. L LOTE. 09 URB. SAN JUAN BAUTISTA DE VILL LIMA - LIMA - CHORRILLOS",
            ubigeo: "150108", nombre: "Almacen Chorrillos" , ruc:'20513963085'
        },
        { 
            codLocal: "0010",direccion: "CAR.CHAGUAL NRO. S/N LA LIBERTAD - PATAZ - PATAZ",
            ubigeo: "130809", nombre: "Unidad Poderosa", ruc:'20513963085'
        },
        { 
            codLocal: "0007",direccion: "CAR. TAYABAMBA NRO. S/N ANX. RETAMAS LA LIBERTAD - PATAZ - PARCOY",
            ubigeo: "130808", nombre: "Unidad Horizonte",ruc:'20513963085'
        },
        { 
            codLocal: "0008",direccion: "JR. TUPAC AMARU NRO. S/N LIMA - YAUYOS - ALIS",
            ubigeo: "151002", nombre: "Unidad Corona",ruc:'20513963085'
        },
        { 
            codLocal: "0009",direccion: "CAR. LIRCAY NRO. 10 HUANCAVELICA - HUANCAVELICA - HUACHOCOLPA",
            ubigeo: "090106", nombre: "Unidad Kolpa",ruc:'20513963085'
        }
    ]);

    let establecimientossermie =ref([

        { 
            codLocal: "0002",direccion: "CAL.MACHU PICCHU MZA. L LOTE. 09 URB. SAN JUAN BAUTISTA DE VILL LIMA - LIMA - CHORRILLOS",
            ubigeo: "150108", nombre: "Almacen Chorrillos" , ruc:'20510935340'
        },
        
        { 
            codLocal: "0003",direccion: "CAR. LIRCAY NRO. 10 HUANCAVELICA - HUANCAVELICA - HUACHOCOLPA",
            ubigeo: "090106", nombre: "Unidad Kolpa",ruc:'20510935340'
        }
    ]);

    let nameLocal = ref('nombre sucursal');    
    let codLocal = ref();
    let passLocal = ref();

    const idCompany = ref(datos_company.value['id'])
    const resp_acceso = ref('blank');
    const loading = ref(false);
    const blocked = ref(false);


    onMounted(async ()=>{

        resp_acceso.value = 'blank'
        surcusalservice.validate_status();
        listaSucursal();
    });

    const accesoSucursal =  ()=>{
        resp_acceso.value = 'blank'
        passLocal.value = '';
        console.log(seleccionarSucursal.value.nombre);
        nameLocal.value = seleccionarSucursal.value.nombre
        codLocal.value = seleccionarSucursal.value.codLocal

        visible.value = true;
    }

    const acceder = async () =>{
        resp_acceso.value = 'blank'
        loading.value = true;blocked.value = true;
        console.log(passLocal.value);
        let resp = await surcusalservice.acceso(codLocal.value, passLocal.value);
        console.log(resp);

        if(resp.data.acceso == true){
            loading.value = false;blocked.value = false;
            resp_acceso.value = true;
            localStorage.setItem('active_sucursal',JSON.stringify(resp.data.sucursal))
            //surcusalservice.validate_status()
            router.push('/guias')

        }else{
            loading.value = false;blocked.value = false;
            resp_acceso.value = false;
            console.log("acceso denegado")
        }    
    }

    const listaSucursal = async () =>{

        let resp = await surcusalservice.listarSucursal(idCompany.value);
        console.log(resp);
    }
    //Acceso






</script>